import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { TwoFaSteps } from '../../SetupTwoFaPage.constant'
import { SetupTwoFaWrapper } from '../SetupTwoFaWrapper'
import styles from './SetupTwoFaSuccess.module.scss'
import { SetupTwoFaSuccessProps } from './SetupTwoFaSuccess.types'

export const SetupTwoFaSuccess: FC<SetupTwoFaSuccessProps> = ({ onSubmit }) => {
  const { t } = useTranslation('auth', {
    keyPrefix: 'setup_two_fa_view.setup_success'
  })

  return (
    <SetupTwoFaWrapper
      title={t('title')}
      description={t('description')}
      primaryButtonLabel={t('submit_button')}
      onPrimaryButtonClick={onSubmit}
      currentStep={TwoFaSteps.SETUP_SUCCESS}
      descriptionClassName={styles.description}
    />
  )
}
